<!--
  Side view of the bank account overview (cr.CustomerBankAccount, TM-1000002030) - the narrow variant of the
  one shared overview component, for the right drawer the Abrechnungs-Landkarte opens.

  `w-full max-w-full` and nothing else on the wrapper: the drawer owns the width. The overflow container that
  keeps a wide table inside the drawer sits on the table itself, in the overview component.

  @ticket TM-1000002030
-->
@if (initialized && dto) {

    <div class="cr-customer-bank-account-overview-side w-full max-w-full mt-3">

        <cr-customer-bank-account-overview
                [bankAccountId]="objectIdentifier.objectId"
                [compact]="true">
        </cr-customer-bank-account-overview>

    </div>

}
